import {AppConfigDataSourceFromType} from "@/model/AppConfigDatasource";

export enum AppConfigGlobalMenuModule {
    Resource = 1,
    Practice = 2,
    News = 3
}

export const AppConfigGlobalMenuModuleMaxLevel = (module?: AppConfigGlobalMenuModule) => {
    switch (module) {
        case AppConfigGlobalMenuModule.Resource:
            return 2
        case AppConfigGlobalMenuModule.Practice:
            return 2
        case AppConfigGlobalMenuModule.News:
            return 1
    }
    return ""
}
export const AppConfigGlobalMenuModuleValues = [AppConfigGlobalMenuModule.Resource, AppConfigGlobalMenuModule.Practice]
export const AppConfigGlobalMenuModuleName = (module: AppConfigGlobalMenuModule) => {
    switch (module) {
        case AppConfigGlobalMenuModule.Resource:
            return "资源模块"
        case AppConfigGlobalMenuModule.Practice:
            return "练习模块"
    }
    return ""
}

export interface AppConfigGlobalMenu extends Record<any, any>{
    id?: string
    name?: string
    module?: AppConfigGlobalMenuModule
    children?: AppConfigGlobalMenu[]
    datasource?: {
        id: string
        name?: string
    },
    subjectId?: string
    // 资讯板块id
    newsSectionId?: string
}